import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { AuthenticationStatus, RequestStatus, User } from '@store/types';
import { app as routes } from '@configs/routes.json';
import { ErrorStateType } from '@models/errors';

import Upload from '../../containers/Upload';
import Login from '../../containers/Login';
import CreateAccount from '../../containers/CreateAccount';
import SetPassword from '../../containers/SetPassword';
import ResetPassword from '../../containers/ResetPassword';
import Orders from '../../containers/Orders';
import OrderDetail from '../../containers/OrderDetail';
import Files from '../../containers/Files';
import FilesHierarchy from '../../containers/FilesHierarchy';
import DownloadResultsPackage from '../../containers/DownloadResultsPackage';
import Help from '../../containers/Help';
import AcceptTermsOfService from '../../containers/AcceptTermsOfService';
import CookiePolicy from '../../containers/CookiePolicy';
import PrivacyPolicy from '../../containers/PrivacyPolicy';

import AlmostThere from '../login/AlmostThere';
import Results from '../results/Results';
import TermsOfService from '../policies/TermsOfService';
import {
  acceptShowTermsOfService,
  AnonymousRoute,
  AuthenticatedRoute,
  showAlmostThere,
} from '../routes/Routes';

export interface RoutesSwitchStateProps {
  status: AuthenticationStatus;
  errors: ErrorStateType[];
  user?: User;
  projectDepDefaultAuthRoute: string;
  getProjectsStatus: RequestStatus;
}

const RoutesSwitch: React.FC<RoutesSwitchStateProps> = ({
  status,
  errors,
  user,
  projectDepDefaultAuthRoute,
  getProjectsStatus,
}) => {
  return (
    <div className='container'>
      <Switch>
        <AuthenticatedRoute
          path={routes.uploads}
          authenticationStatus={status}
          errors={errors}
          user={user}
        >
          <Upload />
        </AuthenticatedRoute>

        <AuthenticatedRoute
          path={routes.orderDetail}
          authenticationStatus={status}
          errors={errors}
          user={user}
        >
          <OrderDetail />
        </AuthenticatedRoute>

        <AuthenticatedRoute
          path={routes.orders}
          authenticationStatus={status}
          errors={errors}
          user={user}
        >
          <Orders />
        </AuthenticatedRoute>

        <AuthenticatedRoute
          path={routes.results}
          authenticationStatus={status}
          errors={errors}
          user={user}
        >
          <Results />
        </AuthenticatedRoute>

        <AuthenticatedRoute
          path={routes.downloadResultsPackage}
          authenticationStatus={status}
          errors={errors}
          user={user}
        >
          <DownloadResultsPackage />
        </AuthenticatedRoute>
        <AuthenticatedRoute
          path={routes.filesHierarchy}
          authenticationStatus={status}
          errors={errors}
          user={user}
        >
          <FilesHierarchy />
        </AuthenticatedRoute>
        <AuthenticatedRoute
          path={routes.files}
          authenticationStatus={status}
          errors={errors}
          user={user}
        >
          <Files />
        </AuthenticatedRoute>

        <Route path={routes.almostThere}>
          {showAlmostThere(status, errors, user) ? (
            <AlmostThere />
          ) : (
            <Redirect
              to={{
                pathname: projectDepDefaultAuthRoute,
              }}
            />
          )}
        </Route>
        <Route path={routes.acceptTermsOfService}>
          {acceptShowTermsOfService(status, errors) ||
          getProjectsStatus !== RequestStatus.completed ? (
            <AcceptTermsOfService />
          ) : (
            <Redirect
              to={{
                pathname: projectDepDefaultAuthRoute,
              }}
            />
          )}
        </Route>
        <AuthenticatedRoute
          path={routes.help}
          authenticationStatus={status}
          errors={errors}
          user={user}
        >
          <Help />
        </AuthenticatedRoute>

        <Route path={routes.cookiePolicy}>
          <CookiePolicy />
        </Route>
        <Route path={routes.termsOfService}>
          <TermsOfService />
        </Route>
        <Route path={routes.privacyPolicy}>
          <PrivacyPolicy />
        </Route>
        <Route path={routes.resetPassword}>
          <ResetPassword />
        </Route>

        <Route path={routes.setPassword}>
          <SetPassword />
        </Route>

        <AnonymousRoute
          path={routes.createAccount}
          authenticationStatus={status}
          errors={errors}
          user={user}
        >
          <CreateAccount />
        </AnonymousRoute>

        <AnonymousRoute
          path={routes.login}
          authenticationStatus={status}
          errors={errors}
          user={user}
        >
          <Login />
        </AnonymousRoute>
      </Switch>
    </div>
  );
};

export default RoutesSwitch;
